import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';


export const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: '#333',
        color: '#fff',
        maxWidth: 500,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);